import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Store second-row nav, styled like the shared section nav (.sp-section-nav).
// Category links use ?category= (the shop's filter chips read the same param); the old
// /shop#merch style links still work on the shop page.
const CATEGORY_LINKS = [
    { id: 'all', label: 'All', to: '/shop', testid: 'shop-nav-market' },
    { id: 'merch', label: 'Merch', to: '/shop?category=merch', testid: 'shop-nav-merch' },
    { id: 'ai-art', label: 'AI art', to: '/shop?category=ai-art', testid: 'shop-nav-art' },
    { id: 'bot-code', label: 'Bot code', to: '/shop?category=bot-code', testid: 'shop-nav-code' },
    { id: 'prompt-packs', label: 'Prompt packs', to: '/shop?category=prompt-packs', testid: 'shop-nav-prompt-packs' },
    { id: 'skill-kits', label: 'Skill kits', to: '/shop?category=skill-kits', testid: 'shop-nav-skill-kits' },
];

const SERVICE_LINKS = [
    { label: 'Automations', to: '/automation-center', testid: 'shop-nav-automations' },
    { label: 'Find my automation', to: '/find-automation', testid: 'shop-nav-finder' },
    { label: 'Pricing', to: '/pricing', testid: 'shop-nav-pricing' },
];

export const ShopNavigation = () => {
    const { pathname, search } = useLocation();
    const onShop = pathname === '/shop';
    const requested = onShop ? new URLSearchParams(search).get('category') : null;
    const current = onShop ? (CATEGORY_LINKS.some((c) => c.id === requested && c.id !== 'all') ? requested : 'all') : null;

    return (
        <nav aria-label="Shop departments" data-testid="shop-navigation" className="sp-section-nav shop-navigation">
            <div className="signal-container">
                {CATEGORY_LINKS.map((c) => (
                    <Link key={c.id} to={c.to} data-testid={c.testid} aria-current={current === c.id ? 'page' : undefined}>
                        {c.label}
                    </Link>
                ))}
                <span className="shop-navigation-divider" aria-hidden="true" />
                {SERVICE_LINKS.map((l) => (
                    <Link key={l.to} to={l.to} data-testid={l.testid}>
                        {l.label}
                    </Link>
                ))}
            </div>
        </nav>
    );
};
